import { all, fork, put, select, takeEvery } from "redux-saga/effects";
import { BetSlipActionTypes, SignalRTypes, SportTypesActionTypes } from "../actions";
import { Cookies, Enums, SessionStorage } from "../../helpers";
const calacBetBuilderTotalPossibleWin = (possibleWinning) => {
  let selectedCurrency = Cookies.get('selectedCurrency');
  let possibleFieldWin = 0;

  if (selectedCurrency.currencyId == 1) {
      if (possibleWinning > 0) {
          let remain = possibleWinning % 5;
          possibleFieldWin =Math.round(possibleWinning - remain);
      }
  } else {
      if (possibleWinning > 0) {
          possibleFieldWin = possibleWinning.toFixed(2);
      }
  }

  return possibleFieldWin;
}

export function* requests() {
  yield takeEvery(SignalRTypes.Get_Custom_Bet_Odd_Field_Data_Success, function*({
    response,
  }) {
    try {
        window.console.response("RES Get_Custom_Bet_Odd_Field_Data_Success=>", response);
        const { general, betSlip, app } = yield select();
        const { betsRestrictions, betSlipConstants } = general;
        console.log("betSlipConstants",betSlipConstants);
        let currency = Cookies.get("selectedCurrency")
        SessionStorage.betTab = 4
        let totalOdds = 0;
        let amount = (general.betSlipConstants && general.betSlipConstants.betSlipAmountLD && general.betSlipConstants.betSlipAmountUSD) ?
        ((currency.currencyId === Enums.Currency.LiberianDollar) ?
            general.betSlipConstants.betSlipAmountLD : general.betSlipConstants.betSlipAmountUSD) : 100;;
        SessionStorage.betBuilder = response
        let list =response
        totalOdds = SessionStorage.betBuilderDisplayOdds;
        console.log("totalOddstotalOdds",totalOdds);
        SessionStorage.betBuilderPossibleWinning=calacBetBuilderTotalPossibleWin(amount * totalOdds)
        SessionStorage.betBuilderAmount= amount
        let betBuilderPossibleWinning =calacBetBuilderTotalPossibleWin(amount * totalOdds)
        yield put({
            type: BetSlipActionTypes.Update_BetBuilder_List_Done,
            customBetData: list,
        })
          yield put({
            type: BetSlipActionTypes.Bet_Builder_Amount_Changed,
            amount
        })
        yield put({
            type: BetSlipActionTypes.Set_BetBuilder_Total_Odds,
            totalOdds,
        })
        yield put({
            type: BetSlipActionTypes.Set_BetBuilder_Possible_Winnings,
            betBuilderPossibleWinning
        })


    } catch (e) {
      window.log("ERROR", e);
    }
  });

}
export default function* CustomBetSaga() {
  yield all([fork(requests)]);
}
